import {Line} from '@visx/shape';
import React from 'react';

import {ERROR_BAR_LINE_WIDTH, POINT_RADIUS} from 'ui-library/charting/internals/utils/Theme';
import {CartesianPoint} from 'ui-library/charting/Types';

import useVisXContext from './hooks/useVisXContext';
import getCartesianErrorRange from './utils/getCartesianErrorRange';

const ERROR_BAR_TICK_LENGTH = POINT_RADIUS + 1;

export interface CartesianErrorBarProps<DataPoint extends CartesianPoint> {
  color: string;
  dataPoint: DataPoint;
  x: number;
}

export default function CartesianErrorBar<DataPoint extends CartesianPoint>({
  color,
  dataPoint,
  x,
}: CartesianErrorBarProps<DataPoint>): JSX.Element | null {
  const {yScale} = useVisXContext('yScale');
  const errorRange = getCartesianErrorRange(dataPoint);

  if (errorRange == null || yScale == null) {
    return null;
  }

  const errorRangePositions = errorRange.map((errorRangeValue) => yScale(errorRangeValue) as number);

  return (
    <>
      <Line
        from={{x, y: errorRangePositions[0]}}
        to={{x, y: errorRangePositions[1]}}
        shapeRendering="geometricPrecision"
        stroke={color}
        strokeWidth={ERROR_BAR_LINE_WIDTH}
      />
      {errorRangePositions.map((position, index) => (
        <Line
          key={index}
          from={{x: x - ERROR_BAR_TICK_LENGTH, y: position}}
          to={{x: x + ERROR_BAR_TICK_LENGTH, y: position}}
          shapeRendering="geometricPrecision"
          stroke={color}
          strokeWidth={ERROR_BAR_LINE_WIDTH}
        />
      ))}
    </>
  );
}
